import { render, staticRenderFns } from "./StepikCourseDialog.vue?vue&type=template&id=1300a9d9"
import script from "./StepikCourseDialog.vue?vue&type=script&lang=js"
export * from "./StepikCourseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports